<template>
  <div class="ui-counter">
    <div :class="[value === min ? 'inactive' : '']" class="button less unselectable xxxs-title" @click="less">
      -
    </div>
    <input type="number" :value="value" class="value xxxs-title" @change="setValue" />
    <div class="button unselectable xxxs-title" @click="more">
      +
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default() {
        return 1
      }
    },
    min: {
      type: Number,
      default() {
        return 1
      }
    },
    max: {
      type: Number,
      default() {
        return 100
      }
    }
  },
  methods: {
    more() {
      this.$emit('input', this.value + 1)
    },
    less() {
      if (this.value === this.min) return false
      this.$emit('input', this.value - 1)
    },
    setValue($event) {
      let value = Number($event.target.value)
      if (value < this.min) {
        value = this.min
      } else if (value > this.max) {
        value = this.max
      }
      $event.target.value = value
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-counter {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  border: solid 1px rgba(0, 0, 0, 0.1);
}
.value {
  // border: solid 1px;
  width: 2.5em;
  text-align: center;
  height: 2.2em;
  font-family: inherit;
  color: inherit;
  border: none;
  // border-radius: 5px;
  // background: #f3f3f7;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
}
.button {
  width: 1.25em;
  height: 1.25em;
  margin: 0 0.3em;
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  position: relative;
  &.inactive {
    opacity: 0.5;
    pointer-events: none;
  }
  &:hover {
    color: var(--main);
  }
  &.less {
    top: -0.2em;
  }
}
</style>
